<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>Esqueci a senha</h1>
                <p class="text-muted">Crie sua conta</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" v-model="email" class="form-control" placeholder="Email" autocomplete="email" />
                </b-input-group>
                <b-alert v-if="errorMessage" show variant="danger">{{errorMessage}}</b-alert>
                <b-alert v-if="success" show variant="success">Pronto! Se este for um email cadastrado você receberá um link para redefinir sua senha. 
                  <br/>
                  <br/>
                  <b>O e-mail não chegou? Veja o que você pode fazer:</b>
                  <br/>
                  - Certifique-se de que o e-mail não está na caixa de spam; ou
                  <br/>
                  - Envie um e-mail para contato@sleeker.pt para nosso time e nós reconfiguramos sua conta; ou
                  <br/>
                  - Entre em contato por whatsapp <a href="https://api.whatsapp.com/send?phone=558199719158&text=Tenho um problema com a senha">clicando aqui</a>.</b-alert>
                <b-button @click="requestPasswordReset" variant="success" block>Recuperar Senha</b-button>
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col>
                  <b-button block class="btn" to="/pages/register"><span>Não tem uma conta? Faça seu cadastro!</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import service from '../../service'

export default {
  name: 'ResetPassword',
  data: function() {
    return {
      email: "",
      errorMessage: undefined,
      success: false
    };
  },
  methods: {
    requestPasswordReset: function() {
      this.success = false;
      this.errorMessage = undefined;

      service.requestPasswordReset(this.email).then(() => {
        this.success = true;
      }).catch(() => {
        this.errorMessage = "Ocorreu um erro. Por favor, procure o suporte.";
      });
      
    }
  }
}
</script>
